// ═══════════════════════════════════════════════════════════════════
//  modules/erp/PlayerBoxesTab.js
//  PlayerBoxesTab
// ═══════════════════════════════════════════════════════════════════

import { Badge } from "../../composants/Badge";
import { THEME } from "../../socle/theme";

export function PlayerBoxesTab({ boxes }) {
  if (boxes.length === 0) return <div style={{ color: THEME.textMuted, fontSize: 13, padding: 20, textAlign: "center" }}>Ce joueur n'est membre d'aucune box.</div>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {boxes.map((box, i) => (
        <div key={i} style={{ background: THEME.panel, border: `1px solid ${box.role === "owner" ? THEME.gold : THEME.border}`, borderRadius: 10, padding: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 20 }}>🏠</span>
              <div>
                <div style={{ color: THEME.text, fontWeight: 700, fontSize: 14 }}>{box.team_id}</div>
                <div style={{ color: THEME.textMuted, fontSize: 11 }}>{box.world_name}</div>
              </div>
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <Badge text={box.role === "owner" ? "👑 Propriétaire" : "👤 Membre"} bg={box.role === "owner" ? THEME.goldDim : THEME.surface} color={box.role === "owner" ? THEME.gold : THEME.textMuted} />
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 }}>
            <div style={{ background: THEME.surface, borderRadius: 6, padding: "8px 12px" }}>
              <div style={{ color: THEME.textMuted, fontSize: 10, fontWeight: 600 }}>NIVEAU</div>
              <div style={{ color: THEME.emerald, fontSize: 16, fontWeight: 700 }}>{box.level}</div>
            </div>
            <div style={{ background: THEME.surface, borderRadius: 6, padding: "8px 12px" }}>
              <div style={{ color: THEME.textMuted, fontSize: 10, fontWeight: 600 }}>TAILLE</div>
              <div style={{ color: THEME.accent, fontSize: 16, fontWeight: 700 }}>{box.size}</div>
            </div>
            <div style={{ background: THEME.surface, borderRadius: 6, padding: "8px 12px" }}>
              <div style={{ color: THEME.textMuted, fontSize: 10, fontWeight: 600 }}>BANQUE</div>
              <div style={{ color: THEME.gold, fontSize: 16, fontWeight: 700 }}>{Number(box.bank || 0).toLocaleString("fr")} 💰</div>
            </div>
          </div>

          <div style={{ display: "flex", gap: 6, marginTop: 10, flexWrap: "wrap" }}>
            {box.can_deposit ? <Badge text="✅ Peut déposer" bg={THEME.emeraldDim} color={THEME.emerald} /> : <Badge text="❌ Pas de dépôt" bg={THEME.redDim} color={THEME.red} />}
            {box.can_withdraw ? <Badge text="✅ Peut retirer" bg={THEME.emeraldDim} color={THEME.emerald} /> : <Badge text="❌ Pas de retrait" bg={THEME.redDim} color={THEME.red} />}
            {box.owner_name && <Badge text={`Propriétaire : ${box.owner_name}`} bg={THEME.goldDim} color={THEME.gold} />}
          </div>

          {box.created_at && (
            <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 8 }}>
              Créée le {new Date(Number(box.created_at)).toLocaleDateString("fr")}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
